/**
 * Mock Implementation of IStudyService
 *
 * SWAP INSTRUCTIONS (when BE ready):
 * 1. Create study.service.api.ts implementing IStudyService
 * 2. Update index.ts to export API implementation instead of mock
 */

import {
  getStudyPageDataMock,
  getDiagnosisQuizSessionMock,
  getWordQuizSessionMock,
  getLevelPracticeSessionMock,
  getTextExplanationSessionMock,
  getRecommendationMock,
} from "@/infrastructure/data/mocks/study";
import { IStudyService } from "@/infrastructure/services/study/study.service";

export const mockStudyService: IStudyService = {
  getPageData: getStudyPageDataMock,
  getDiagnosisQuizSession: () => getDiagnosisQuizSessionMock(),
  getDiagnosisQuizMetadata: async (_subjectId) => ({ totalQuestions: 0 }),
  submitDiagnosisAnswer: async (_sessionId, answer) => ({ sessionItemId: answer.sessionItemId, correctIndex: 0 }),
  getWordPracticeSession: async () => ({ words: [], totalCount: 0 }),
  getWordQuizSession: (_subjectId) => getWordQuizSessionMock(),
  getLevelPracticeSession: (subjectId, level) => getLevelPracticeSessionMock(subjectId, level),
  getTextExplanationSession: () => getTextExplanationSessionMock(),
  getRecommendation: () => getRecommendationMock(),
  getSubjectLevels: async () => ({
    levels: [],
    textbookFileUrl: "",
    vocabularyCount: 0,
    learnedVocabularyCount: 0,
    isVocabularyQuizCompleted: false,
    currentLevel: "lv0",
  }),
  createSubjectQuizSession: async () => ({ quizSessionId: "", totalQuestions: 0, questions: [] }),
  submitSubjectQuizAnswer: async () => ({
    sessionItemId: "",
    isCorrect: false,
    correctCount: 0,
    wrongCount: 0,
    answeredCount: 0,
    totalQuestions: 0,
    isCompleted: false,
  }),
  getSubjectQuizResult: async () => ({
    quizSessionId: "",
    correctCount: 0,
    wrongCount: 0,
    totalQuestions: 0,
    accuracyRate: 0,
    items: [],
    isCompleted: false,
    answeredCount: 0,
  }),
  updateVocabularyProgress: async () => true,
  createVocabularyQuizSession: async () => ({ quizSessionId: "", totalQuestions: 0, questions: [] }),
  submitVocabularyQuizAnswer: async () => ({
    sessionItemId: "",
    isCorrect: false,
    correctCount: 0,
    wrongCount: 0,
    answeredCount: 0,
    totalQuestions: 0,
    isCompleted: false,
  }),
  getVocabularyQuizResult: async () => ({
    quizSessionId: "",
    correctCount: 0,
    wrongCount: 0,
    answeredCount: 0,
    totalQuestions: 0,
    accuracyRate: 0,
    isCompleted: false,
    items: [],
  }),
  skipLevelAssessment: async (subjectId: string) => ({ subjectId: Number(subjectId), level: "lv0" }),
  createSubjectQuizPracticeSession: async () => ({ quizSessionId: "", totalQuestions: 0, questions: [] }),
  submitSubjectQuizPracticeAnswer: async () => ({
    sessionItemId: "",
    isCorrect: false,
    correctChoiceId: "",
    explanation: "",
    translatedExplanation: null,
    correctCount: 0,
    wrongCount: 0,
    answeredCount: 0,
    totalQuestions: 0,
    isCompleted: false,
    nextQuestion: null,
  }),
  getSubjectQuizPracticeResult: async () => ({
    quizSessionId: "",
    correctCount: 0,
    wrongCount: 0,
    answeredCount: 0,
    totalQuestions: 0,
    accuracyRate: 0,
    isCompleted: true,
    items: [],
  }),
  getBoostMessage: async () => null,
};
